var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"mb-2",staticStyle:{"z-index":"200"},attrs:{"color":"rgb(0, 96, 99)","dark":"","elevation":"4","fixed":"","bottom":"","right":""},on:{"click":function($event){return _vm.openFreshdesk()}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-help-circle-outline")]),_vm._v("Hilfe ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }